import React, { useState, useCallback } from 'react'

// Base URL
const baseUrl = process.env.REACT_APP_PRESTWATCH_API_URL

function useHttp(){
    // State Management
    const [ isLoading, setIsLoading ] = useState(false)
    const [ error, setError ] = useState(false)
    const [ success, setSuccess ] = useState(false)
    const [ data, setData ] = useState(false)

    // Request Sending Async Function
    const sendRequest = useCallback(async (url, reqConfig={}) => {
        // Parameters Setting
        const method = reqConfig.method ?? 'GET'
        const headers =  {'Content-Type': 'application/json', ...reqConfig.headers}
        const body = reqConfig.body ? JSON.stringify(reqConfig.body) : null

        // State Setting
        setIsLoading(true)
        setError(false)
        setSuccess(false)
        setData(false)

        // Sending Request
        try{
            // Response and Error Handling
            const response =  await fetch(baseUrl + url, {method: method, headers: headers, body: body})
            if (!response.ok) throw new Error(`${response.status} ${response.statusText}`);

            // Data Extraction and Error Handling
            const data = await response.json()
            if (data.error) throw new Error(data.error);

            // Successful Request
            setData(data.data)
            setSuccess(true)
        }catch(error){
            setError(error.message)
        }finally {
            setIsLoading(false)
        }
    }, [])

    // Hook State and Functionality
    return { baseUrl, isLoading, error, success, data, sendRequest }
}

export default useHttp